// Short and friendly for the M2 friend test; the room code doubles as the
// room id. M3 replaces guessable codes with control-plane session tokens.
export const INVITE_PARAM = "share";
export const SESSION_STORAGE_KEY = "swf:session";
export const IDENTITY_STORAGE_KEY = "swf:identity";

export const MAX_ROOM_MEMBERS = 8;
export const MAX_CHAT_MESSAGES = 200;
export const MAX_CHAT_LENGTH = 500;
export const MAX_DISPLAY_NAME_LENGTH = 32;

export const AVATAR_PALETTE = [
  "#e05252",
  "#3a86c8",
  "#43a06b",
  "#c8763a",
  "#8657c8",
  "#c84f9b",
  "#3aa8a8",
  "#a0a03a",
] as const;
